import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-pos-solution',
  templateUrl: './pos-solution.component.html',
  styleUrls: ['./pos-solution.component.scss']
})
export class PosSolutionComponent implements OnInit {


  constructor(private meta: Meta) { 
    this.meta.removeTag('name=keywords');
    this.meta.removeTag('name=description');
    this.meta.addTags([ 
      { name: 'description', content: 'Explore our advanced Point of Sale (POS) solutions at OSIT. We specialize in providing state-of-the-art POS software and systems to enhance your retail and restaurant businesses in Riyadh, Saudi Arabia. Discover how our POS solutions can optimize your sales, inventory management, and customer experience.' }, 
      { name: 'keywords', content: 'osit,it,saudi it,software development,website development' } 
  ]);
  }

  ngOnInit() {
  }

}
